import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { LoteCertificadoComponent } from './lote-certificado';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

@NgModule({
  declarations: [LoteCertificadoComponent],
  imports: [
    SharedModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
],
  exports: [
    LoteCertificadoComponent // Exporta el componente para que otros módulos puedan usarlo
  ]
})
export class LoteCertificadoModule { }
